"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    // write code here
    var notification = document.createElement("div");
    notification.classList.add("notification", type);
    notification.style.top = "".concat(posTop, "px");
    notification.style.right = "".concat(posRight, "px");
    var titleEl = document.createElement("h2");
    titleEl.classList.add("title");
    titleEl.textContent = title;
    var descEl = document.createElement("p");
    descEl.textContent = description;
    notification.append(titleEl, descEl);
    document.body.appendChild(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.5a054f3b.js.map
